<div class="LuggageWeighing-textDescription">
    <span class="LuggageWeighing-textDescription" >
        <span class="fs-28px">
            {{ 'luggageWeighing.weighing' | translate }}
        </span>
        <span class="fs-24px">
            <b>{{maxWeight}}</b>
        </span>
    </span>
</div>

<div class="LuggageWeighing-weightCircle" [ngClass]="{'LuggageWeighing-weightCircle--overweight': currentBag?.isExtraWeight, 'LuggageWeighing-weightCircle--success': weight > 0 && weight <= bagLimit, 'LuggageWeighing-weightCircle--wait': weight == 0 }">
    <div class="fs-142px formatkg">{{ weight }}</div>
    <div class="fs-52px">{{ 'luggageWeighing.kg' | translate }}</div>
</div>
<div class="NoticeOnboardingComponent_icon_margin" *ngIf="weight > bagLimit">
    <img class="NoticeOnboardingComponent_icon_size" src="../../../assets/images/alert/Warningblue.svg" alt="alert">
</div>
